export default __webpack_public_path__ + "static/product-centrik-8184d84a7e1b39b7e57bd563df78123d.svg";